import React, { useState, useEffect } from "react";
import axios from "axios";
import "./EmailSubscription.css";

const EmailSubscription = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" | "error"
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => setEmail(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setMessageType("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      await axios.post("/api/news-subscribe", { email });
      setMessageType("success");
      setMessage("Thank you for subscribing!");
      setEmail("");
    } catch (error) {
      if (error.response?.status === 409) {
        setMessageType("error");
        setMessage("This email is already subscribed.");
      } else {
        console.error("Error:", error);
        setMessageType("error");
        setMessage("Subscription failed. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Clear the message after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div className="email-subscription" role="region" aria-label="Newsletter subscription">
      <h2>Subscribe to Our Newsletter</h2>
      <p>Stay updated with the latest news, insights, and trends.</p>

      <form className="subscription-form" onSubmit={handleSubmit} noValidate>
        {/* Accessible label (visually hidden) */}
        <label htmlFor="newsletter-email" className="sr-only">
          Email address
        </label>
        <input
          id="newsletter-email"
          type="email"
          placeholder="Enter your email"
          className="email-input"
          value={email}
          onChange={handleInputChange}
          required
          autoComplete="email"
          inputMode="email"
        />

        <button
          type="submit"
          className="subscribe-button"
          disabled={loading}
          aria-disabled={loading}
        >
          {loading ? "Subscribing…" : "Subscribe"}
        </button>
      </form>

      {message && (
        <div
          className={`subscription-message ${messageType === "success" ? "success" : "error"}`}
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default EmailSubscription;
